var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _rect6, _rect7, _rect8, _rect9, _rect10, _path3, _path4, _rect11, _rect12, _rect13, _rect14, _rect15, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPropertiesImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 903,
    height: 324,
    viewBox: "0 0 903 324",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 285,
    height: 324,
    rx: 10,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 284,
    height: 323,
    rx: 9.5,
    stroke: "url(#paint0_linear_17582_247612)",
    strokeOpacity: 0.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 16,
    width: 261,
    height: 160,
    rx: 8,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 16,
    width: 261,
    height: 160,
    rx: 8,
    fill: "#4EBBB8",
    fillOpacity: 0.05
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 16.5,
    width: 260,
    height: 159,
    rx: 7.5,
    stroke: "url(#paint1_linear_17582_247612)",
    strokeOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.098 115.278L117.043 115.333C116.301 113.71 115.833 111.868 115.641 109.833C115.833 111.84 116.356 113.655 117.098 115.278ZM134.753 91.5451C136.489 91.5451 138.154 90.8555 139.381 89.6281C140.609 88.4007 141.298 86.7359 141.298 85.0001C141.298 83.2642 140.609 81.5995 139.381 80.3721C138.154 79.1446 136.489 78.4551 134.753 78.4551C133.017 78.4551 131.353 79.1446 130.125 80.3721C128.898 81.5995 128.208 83.2642 128.208 85.0001C128.208 86.7359 128.898 88.4007 130.125 89.6281C131.353 90.8555 133.017 91.5451 134.753 91.5451Z",
    fill: "#4EBBB8",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.523 68.5H131.477C121.467 68.5 115.5 74.4675 115.5 84.4775V107.523C115.5 110.52 116.022 113.133 117.04 115.333C119.405 120.558 124.465 123.5 131.477 123.5H154.523C164.533 123.5 170.5 117.533 170.5 107.523V84.4775C170.5 74.4675 164.533 68.5 154.523 68.5ZM166.018 97.375C163.873 95.5325 160.407 95.5325 158.262 97.375L146.823 107.192C144.678 109.035 141.212 109.035 139.067 107.192L138.132 106.423C136.18 104.717 133.073 104.552 130.873 106.037L120.587 112.94C119.982 111.4 119.625 109.613 119.625 107.523V84.4775C119.625 76.7225 123.722 72.625 131.477 72.625H154.523C162.278 72.625 166.375 76.7225 166.375 84.4775V97.6775L166.018 97.375Z",
    fill: "#4EBBB8",
    fillOpacity: 0.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 309,
    width: 285,
    height: 324,
    rx: 10,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 309.5,
    y: 0.5,
    width: 284,
    height: 323,
    rx: 9.5,
    stroke: "url(#paint2_linear_17582_247612)",
    strokeOpacity: 0.4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 321,
    y: 16,
    width: 261,
    height: 160,
    rx: 8,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 321,
    y: 16,
    width: 261,
    height: 160,
    rx: 8,
    fill: "#4EBBB8",
    fillOpacity: 0.05
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 321.5,
    y: 16.5,
    width: 260,
    height: 159,
    rx: 7.5,
    stroke: "url(#paint3_linear_17582_247612)",
    strokeOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M426.098 115.278L426.043 115.333C425.301 113.71 424.833 111.868 424.641 109.833C424.833 111.84 425.356 113.655 426.098 115.278ZM443.753 91.5451C445.489 91.5451 447.154 90.8555 448.381 89.6281C449.609 88.4007 450.298 86.7359 450.298 85.0001C450.298 83.2642 449.609 81.5995 448.381 80.3721C447.154 79.1446 445.489 78.4551 443.753 78.4551C442.017 78.4551 440.353 79.1446 439.125 80.3721C437.898 81.5995 437.208 83.2642 437.208 85.0001C437.208 86.7359 437.898 88.4007 439.125 89.6281C440.353 90.8555 442.017 91.5451 443.753 91.5451Z",
    fill: "#4EBBB8",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M463.523 68.5H440.477C430.467 68.5 424.5 74.4675 424.5 84.4775V107.523C424.5 110.52 425.022 113.133 426.04 115.333C428.405 120.558 433.465 123.5 440.477 123.5H463.523C473.533 123.5 479.5 117.533 479.5 107.523V84.4775C479.5 74.4675 473.533 68.5 463.523 68.5ZM475.018 97.375C472.873 95.5325 469.407 95.5325 467.262 97.375L455.823 107.192C453.678 109.035 450.212 109.035 448.067 107.192L447.132 106.423C445.18 104.717 442.073 104.552 439.873 106.037L429.587 112.94C428.982 111.4 428.625 109.613 428.625 107.523V84.4775C428.625 76.7225 432.722 72.625 440.477 72.625H463.523C471.278 72.625 475.375 76.7225 475.375 84.4775V97.6775L475.018 97.375Z",
    fill: "#4EBBB8",
    fillOpacity: 0.6
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 618,
    width: 285,
    height: 324,
    rx: 10,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 618.5,
    y: 0.5,
    width: 284,
    height: 323,
    rx: 9.5,
    stroke: "url(#paint4_linear_17582_247612)",
    strokeOpacity: 0.4
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 16,
    width: 261,
    height: 160,
    rx: 8,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 16,
    width: 261,
    height: 160,
    rx: 8,
    fill: "#4EBBB8",
    fillOpacity: 0.05
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 630.5,
    y: 16.5,
    width: 260,
    height: 159,
    rx: 7.5,
    stroke: "url(#paint5_linear_17582_247612)",
    strokeOpacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M735.098 115.278L735.043 115.333C734.301 113.71 733.833 111.868 733.641 109.833C733.833 111.84 734.356 113.655 735.098 115.278ZM752.753 91.5451C754.489 91.5451 756.154 90.8555 757.381 89.6281C758.609 88.4007 759.298 86.7359 759.298 85.0001C759.298 83.2642 758.609 81.5995 757.381 80.3721C756.154 79.1446 754.489 78.4551 752.753 78.4551C751.017 78.4551 749.353 79.1446 748.125 80.3721C746.898 81.5995 746.208 83.2642 746.208 85.0001C746.208 86.7359 746.898 88.4007 748.125 89.6281C749.353 90.8555 751.017 91.5451 752.753 91.5451Z",
    fill: "#4EBBB8",
    fillOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M772.523 68.5H749.477C739.467 68.5 733.5 74.4675 733.5 84.4775V107.523C733.5 110.52 734.022 113.133 735.04 115.333C737.405 120.558 742.465 123.5 749.477 123.5H772.523C782.533 123.5 788.5 117.533 788.5 107.523V84.4775C788.5 74.4675 782.533 68.5 772.523 68.5ZM784.018 97.375C781.873 95.5325 778.407 95.5325 776.262 97.375L764.823 107.192C762.678 109.035 759.212 109.035 757.067 107.192L756.132 106.423C754.18 104.717 751.073 104.552 748.873 106.037L738.587 112.94C737.982 111.4 737.625 109.613 737.625 107.523V84.4775C737.625 76.7225 741.722 72.625 749.477 72.625H772.523C780.278 72.625 784.375 76.7225 784.375 84.4775V97.6775L784.018 97.375Z",
    fill: "#4EBBB8",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17582_247612",
    x1: -9.77941,
    y1: 179.053,
    x2: 297.574,
    y2: 179.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0067438,
    stopColor: "#3176BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EBBB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17582_247612",
    x1: 3.04412,
    y1: 104.421,
    x2: 284.515,
    y2: 104.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0067438,
    stopColor: "#3176BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EBBB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17582_247612",
    x1: 299.221,
    y1: 179.053,
    x2: 606.574,
    y2: 179.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0067438,
    stopColor: "#3176BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EBBB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17582_247612",
    x1: 312.044,
    y1: 104.421,
    x2: 593.515,
    y2: 104.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0067438,
    stopColor: "#3176BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EBBB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_17582_247612",
    x1: 608.221,
    y1: 179.053,
    x2: 915.574,
    y2: 179.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0067438,
    stopColor: "#3176BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EBBB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_17582_247612",
    x1: 621.044,
    y1: 104.421,
    x2: 902.515,
    y2: 104.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0067438,
    stopColor: "#3176BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EBBB8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertiesImages);
export default __webpack_public_path__ + "static/media/properties-images.b36fae16f99879d7946ee40a5f640949.svg";
export { ForwardRef as ReactComponent };